import { FC } from 'react';

import { useBusinessToolSessionStore } from 'store/useBusinessToolStore';
import { getBusinessToolMode } from 'store/useBusinessToolStore/selectors';

import { checkIsPreviewMode } from 'pages/BusinessToolPage/utils';

import { Responsive } from 'components/_basic/Responsive';
import { BottomNavigationButtonsMobile } from 'components/BottomNavigationButtonsMobile/BottomNavigationButtonsMobile';
import { OnePageTypeSwitch } from 'components/OnePage';

import { OnePageSectionsNavigation } from './OnePageSectionsNavigation';
import { TNavigationRenderFn } from '../../../types';
import { ModeSwitch } from '../../ModeSwitch/ModeSwitch';

interface IOnePageNavigationProps {
  render: TNavigationRenderFn;
}

export const OnePageNavigation: FC<IOnePageNavigationProps> = ({ render }) => {
  const businessToolMode = useBusinessToolSessionStore(getBusinessToolMode);
  const isPreviewMode = checkIsPreviewMode(businessToolMode);

  return render({
    modeSwitch: <ModeSwitch />,
    typeSwitch: <Responsive aboveMobile>{!isPreviewMode && <OnePageTypeSwitch />}</Responsive>,
    sectionsNavigation: !isPreviewMode && <OnePageSectionsNavigation />,
    navigationButtons: !isPreviewMode && <BottomNavigationButtonsMobile />,
  });
};
